import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('dashboard', 'change-paid-status-req');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    'virtual_visits',
    {
      type: 'payload',
      selector: ['appointmentId'],
    },
    'payment_status_changes',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/dashboard/requests/change-paid-status-req.js